export enum StoreDialogVisibility {
  None,
  Add,
  Add2s,
  Close,
  Convert,
  Edit,
  Sell,
  UpdateHistory
}
